module.exports = __webpack_public_path__ + "media/images/job_bg-2ecce6e8395b15493280053a6a01b0e9.png";